import { TranslationType } from '../../../../HbtPortfolioManagementTable/types';
import { SeverityCodes } from '../../RightPaneContent/types';

export const errorSeverityMapping = (t: TranslationType) => {
  return {
    [SeverityCodes.error]: t('Pi-Portfolio-Management-Errors'),
    [SeverityCodes.requiresReview]: t('Pi-Portfolio-Management-Requires-Review'),
    [SeverityCodes.warning]: t('Pi-Portfolio-Management-Warnings'),
    [SeverityCodes.info]: t('Pi-Portfolio-Management-Informational')
  };
};

export const errorSeverityMappingForChipLabel = (t: TranslationType) => {
  return {
    [SeverityCodes.error]: t('Pi-Portfolio-Management-Error'),
    [SeverityCodes.requiresReview]: t('Pi-Portfolio-Management-Requires-Review'),
    [SeverityCodes.warning]: t('Pi-Portfolio-Management-Warning'),
    [SeverityCodes.info]: t('Pi-Portfolio-Management-Informational')
  };
};
